export default __webpack_public_path__ + "static/media/whopper-ubereats.8facf521.png";